import { forwardRef, memo, useRef, useState } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';

import { Loader } from '../component';
import { AnimatedSlider, SliderRef } from '../animated-slider';

import {
  InteractiveBox,
  InteractiveForwardRefProps,
} from '@/components/interactive';

const ProgressLoader = memo(
  forwardRef<InteractiveForwardRefProps>((_, ref) => {
    const [start, setStart] = useState(0);
    const sliderRef = useRef<SliderRef>(null);

    return (
      <View style={styles.container}>
        <View style={styles.loaderContainer}>
          <Loader type="with-progress" ref={ref} start={start} />
        </View>
        <View style={styles.sliderContainer}>
          <AnimatedSlider
            ref={sliderRef}
            label="Start"
            value={start}
            onValueChange={setStart}
          />
        </View>
      </View>
    );
  })
);

export function InteractiveProgressLoader() {
  return (
    <InteractiveBox
      children={ProgressLoader}
      theme="light"
      style={{
        aspectRatio:
          Dimensions.get('window').width > Dimensions.get('window').height
            ? undefined
            : 1,
      }}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    gap: 20,
    flex: 1,
    justifyContent: 'center',
  },
  loaderContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
  },
  sliderContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    marginBottom: 20,
  },
});
